module.exports = function(data){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='<div version="'+
((__t=(VERSION))==null?'':__t)+
'" data-noticeid="'+
((__t=(data.id))==null?'':__t)+
'"\n  class="notifications md__notification__commons '+
((__t=(data.noticeClass))==null?'':__t)+
'" style="z-index:100;">\n  <div class="md__notification__header">\n    <div class="flex gap-12 align-center justify-space-between">\n      <div class="flex align-center gap-20">\n        <i id="alert-icon" class="'+
((__t=(data.icon))==null?'':__t)+
' h24 w32 f32"></i>\n        <h4 class="md__notification__title">\n          '+
((__t=(data.title))==null?'':__t)+
'\n        </h4>\n      </div>\n      <button class="close" type="button"><i class="ri-close-line"></i></button>\n    </div>\n  </div>\n  <div class="md__notification__body">\n    '+
((__t=(data.body))==null?'':__t)+
'\n  </div>\n</div>';
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/notice.html
 ** module id = 7
 ** module chunks = 0
 **/